import useSWR from "swr"

import API from "./api"

export default function useBatchPhotos({ viewType, viewId }) {
  const batchKey = viewId ? `batch-photos:${viewType}:${viewId}` : null

  const { data } = useSWR(
    batchKey,
    () =>
      API.get("attachments/batch_images", {
        view_type: viewType,
        view_id: viewId,
      }),
    { suspense: true }
  )

  return data
}
